export default __webpack_public_path__ + "static/media/penbox.6d70cd30.png";